// extracted by mini-css-extract-plugin
export var portfolioContainer = "portfolio-module--portfolioContainer--on1cZ";
export var column = "portfolio-module--column--V5tvO";
export var buttonColumn = "portfolio-module--buttonColumn--lqa-g";
export var link = "portfolio-module--link--DR4SE";